<script setup>

import { useAuthStore } from '@/store/auth';
const authStore = useAuthStore();
</script>

<template>
  <div class="fixed-plugin">
    <!-- Botón para abrir el modal -->
    <a
      class="px-3 py-2 fixed-plugin-button text-dark position-fixed"
      data-bs-toggle="modal"
      data-bs-target="#archivoModal"
    >
      <i class="py-2 fa fa-cog"></i>
    </a>

    <!-- Modal personalizado -->
    <div class="modal fade" id="archivoModal" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content custom-modal">
          <div class="modal-header border-0 text-center">
            <h5 class="modal-title w-100 text-xl">Archivos Disponibles</h5>
          </div>
          <div class="modal-body text-center">
            <ul class="list-unstyled">
              <li v-for="(archivo, index) in authStore.listReport" :key="index">
                <a :href="archivo.link" target="_blank" class="archivo-link">
                  <i class="fa fa-file-alt archivo-icon"></i> {{ archivo.name }}
                </a>
              </li>
            </ul>
          </div>

          <div class="modal-footer border-0 justify-content-center">
            <button type="button" class="btn btn-primary" style="background-color: #706F6F;" data-bs-dismiss="modal">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Modal personalizado */
.custom-modal {
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  background: #ffffff;
  text-align: center;
}

/* Lista de archivos */
.archivo-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #333;
  font-size: 16px;
  padding: 8px;
  border-radius: 5px;
  transition: 0.3s;
}

.archivo-link:hover {
  background: #f8f9fa;
  color: #0B2A33;
}

.archivo-icon {
  font-size: 20px;
  color: #706F6F;
}
</style>
